import React, { useState, useEffect } from 'react';
import * as Yup from "yup";
import NICForm from './NICForm'
import { Paper, withStyles, Dialog, CircularProgress } from "@material-ui/core";
import { BackButton, hasPermission, parseURL } from '../../sc-utilities';
import { connect } from "react-redux";
import * as actions from "./store/nicActions";
import History from "../../../History";
import AppLogoLoading from '../../sc-logo';

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        paddingRight: theme.spacing(6),
        margin: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        }
    },
    submit: {
        backgroundColor: "transparent",
        boxShadow: "none",
        overflow: "hidden",
        alignItems: "center"
    },

    cancel: {
        width: "250px",
        margin: "10px"
    }
});

const NICEdit = props => {
    const { nic, loading, classes, onFetchNICInit, activeCustomer, translations, permissions } = props;
    const [data, setData] = useState(true);
    let searchParams = parseURL(window.location.search);

    const handleSubmit = async data => {
        data['ComponentID'] = nic.ComponentID;
        data['ComponentType'] = 'nic';
        data['ProductID'] = searchParams.productID;

        let result = await props.onEditNIC({ ...data, ActiveCustomerID: activeCustomer });
        if (result) {
            History.goBack()
        }
    }
    useEffect(() => {
        const fetchData = async () => {
            await props.onFetchNIC({ ActiveCustomerID: activeCustomer, ComponentID: parseURL(window.location.href).ComponentID })
            setData(false)
        }
        fetchData();
        return () => {
            onFetchNICInit();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    let initialValues = {
        ComponentType: "nic",
        Vendor: nic.Vendor || "",
        ComponentModel: nic.ComponentModel || '',
        SerialNumber: nic.SerialNumber || '',
        LogicalName: nic && nic.NetworkAdapterComponents && nic.NetworkAdapterComponents.length > 0 ? nic.NetworkAdapterComponents[0].LogicalName : '',
        Capacity: nic && nic.NetworkAdapterComponents && nic.NetworkAdapterComponents.length > 0 ? nic.NetworkAdapterComponents[0].Capacity : 0,
        Description: nic.Description || ''
    };
    let formSettings = {
        Validation: {
            ComponentType: Yup.string().required("Required"),
            Vendor: Yup.string().required("Required"),
            ComponentModel: Yup.string().required("Required"),
            SerialNumber: Yup.string().required("Required"),
            Description: Yup.string().required("Required"),
            LogicalName: Yup.string().required("Required"),
            Capacity: Yup.number().required("Required"),
        },
        FormTitle: translations['edit_nic_component'] || "Edit nic component",
        ButtonSubmit: searchParams.editable === '1' && hasPermission(permissions, "component_save")
            ? {
                Title: translations["save"] || "SAVE",
                Color: 'primary'
            }
            : null,
    };

    return (
        <Paper className={classes.root} >
            {BackButton(translations)}
            <Dialog disableBackdropClick={true} disableEscapeKeyDown={false} open={data}
                PaperProps={{
                    classes: {
                        root: classes.submit
                    }
                }} >

                <AppLogoLoading />
            </Dialog>
            {!data ?
                <NICForm
                    formSettings={formSettings}
                    initialValues={initialValues}
                    handleSubmit={handleSubmit}
                    loading={loading}
                    translations={translations}
                ></NICForm>
                : <CircularProgress
                    variant="static"
                    color="primary"
                    size={28}
                />}
        </Paper>)
}

const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        permissions: state?.core?.login?.permissions || [],
        nic: state.product.nics.loaded ? state.product.nics.loaded : {},
        translations:
            state.translate && state.translate.translations
                ? state.translate.translations.activeTranslations || {}
                : {},
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onFetchNICInit: nic => dispatch(actions.loadNICInit(nic)),
        onFetchNIC: nic => dispatch(actions.loadNIC(nic)),
        onEditNIC: nic => dispatch(actions.editNIC(nic)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(NICEdit));
